import React, { type ReactNode } from 'react';
import { Typography, TypographyVariant } from 'components/Typography';
import Markdown, { defaultRenderers } from 'components/Markdown';

const renderers = {
  ...defaultRenderers,
  paragraph: ({ children }: { children: ReactNode }) => (
    <Typography variant={TypographyVariant.BodyXs}>
      <p className="accessDenied__help">{children}</p>
    </Typography>
  )
};

interface Props {
  email: string;
  children: string[]; // ex: ['this {email} will be replaced', 'with {email} prop']
  help?: string[];
}

const AccessDeniedContent = ({ children, email, help }: Props) => (
  <>
    {children?.map((p) => (
      <Typography variant={TypographyVariant.BodySm} key={p}>
        <p>
          {p.split('{email}').map(
            (string: string, i: number): ReactNode =>
              i === 0 ? (
                string
              ) : (
                <>
                  <Typography variant={TypographyVariant.BodySmStrong}>
                    <b>{email}</b>
                  </Typography>
                  {string}
                </>
              )
          )}
        </p>
      </Typography>
    ))}
    {help && (
      <>
        {help.map((p) => (
          <Markdown key={p} content={p} renderers={renderers} />
        ))}
      </>
    )}
  </>
);

export default AccessDeniedContent;
